import { Injectable } from '@jkhy/frontend-utils/di';
import { AchImportLayoutClient } from '@treasury/api/channel';
import { AchImportLayout } from './ach-import-layout.entity';

@Injectable()
export class AchImportLayoutService {
    constructor(private readonly client: AchImportLayoutClient) {}

    public async getImportLayout(): Promise<AchImportLayout> {
        const response = await this.client.achImportLayoutGet();
        return new AchImportLayout(response.data);
    }

    public async saveImportLayout(layout: AchImportLayout): Promise<AchImportLayout> {
        const response = await this.client.achImportLayoutPut(layout.toSaveDto());
        return new AchImportLayout(response.data);
    }
}
